import type { RegisterCfdType } from '@vend/types/register'

import { useRegisterManager } from '../../../ng-compat/hooks'
import { CFD_TYPE } from '../constants'

/**
 * Returns the CFD type for the active register.
 */
export const useRegisterCfdType = (): RegisterCfdType =>
  useRegisterManager().getActiveRegister().cfd_type

/**
 * Convenience wrapper for the common check.
 */
export const useIsByodCfd = (): boolean =>
  useRegisterCfdType() === CFD_TYPE.BYOD
